import { gql } from '@apollo/client';

export const MY_EARNING_COMMISSIONS = gql`
  query MyEarningCommissions($payload: PageCountInput!, $filters: MyEarningFilter!) {
    myEarningCommissions(payload: $payload, filters: $filters) {
      rows {
        id
        placementId
        companyName
        candidateName
        jobTitle
        startDate
        rateType
        commissionRate
        entryType
        commissionSide
        status
        commissionAmount
        invoiceNumber
        payableTerm
        dueDate
        payout
      }
      count
      totalProjected
      totalEarned
    }
  }
`;

// GraphQL enums serialize their KEYS, so these arrive upper-cased over the wire.
// EARNED is labelled "Received" in the UI; the wire value is unchanged.
export type MyEarningStatus = 'PROJECTED' | 'EARNED';
export type MyEarningEntryType = 'COMMISSION' | 'CLAWBACK';
export type MyEarningRateType = 'PERCENTAGE' | 'FLAT_RATE';
export type MyEarningSide = 'AM' | 'RECRUITING';

export interface MyEarningRow {
  id: string;
  placementId: number | null;
  companyName: string | null;
  candidateName: string | null;
  jobTitle: string | null;
  startDate: string | null;
  rateType: MyEarningRateType | null;
  commissionRate: number | null;
  entryType: MyEarningEntryType;
  commissionSide: MyEarningSide;
  status: MyEarningStatus;
  commissionAmount: number;
  invoiceNumber: string | null;
  payableTerm: string | null;
  dueDate: string | null;
  payout: string | null;
}

export interface MyEarningResult {
  rows: MyEarningRow[];
  count: number;
  totalProjected: number;
  totalEarned: number;
}

export interface MyEarningQueryData {
  myEarningCommissions: MyEarningResult;
}

export interface MyEarningFilter {
  fromDate?: string;
  toDate?: string;
  dateType?: string;
  companySearch?: string;
  candidateSearch?: string;
  jobTitleSearch?: string;
  invoiceSearch?: string;
  statusSearch?: string;
  // Prefix-matched server-side: 16 finds 1622, 1634, …
  idSearch?: number;
  startDateSearch?: string;
  placeDateSearch?: string;
  sorting?: {
    columnName: string;
    columnValue: string;
  };
}
